<script lang="ts">
	import type { ChartFilterType } from 'customTypes/filterTypes';
	import { _ } from 'utils/i18/i18n';
	import FilterButton from 'components/FilterButton/FilterButton.svelte';

	export let dark = false;
	export let chartFilterType: ChartFilterType = 'price';

	function handleButtonClick(e: MouseEvent & { target: HTMLButtonElement }) {
		chartFilterType = e.target.id.slice(0,-4) as ChartFilterType;
	}
</script>

<div class="chart-filter-tab container">
	<FilterButton
		{dark}
		title={$_('general.price')}
		id={'price-tab'}
		isActive={chartFilterType === 'price'}
		on:click={handleButtonClick}
	/>
	<FilterButton
		{dark}
		title={$_('general.marketCap')}
		id={'marketCap-tab'}
		isActive={chartFilterType === 'marketCap'}
		on:click={handleButtonClick}
	/>
	<FilterButton
		{dark}
		title={$_('coinDetailed.tradingVolume')}
		id={'volume-tab'}
		isActive={chartFilterType === 'volume'}
		on:click={handleButtonClick}
	/>
	<!-- <FilterButton
		{dark}
		title={'bitcoin depth'}
		id={'depth'}
		isActive={chartFilterType === 'depth'}
		on:click={handleButtonClick}
	/> -->
</div>

<style lang="scss">
	@import 'ChartFilterTab';
</style>
